var user_info = {
  account: null,
  user_id: null,
  access_token: null,
  friend_id: null,
  phone: null,
};

var timestamp = new Date().getTime();
var api = "//api.qingcigame.com";
var isClaickNav = false;
var person = "";
var newsList = [];
var all_article = [];
var cur_num = "01"; // 当前页码
var num_times; // 可以点的次数
var completed_num = 0; // 真正获取到的线索数量
var map_list; // 点亮图片的数组
var invitation_code; // 邀请码
var task_list;
var first;
var second;
var third;
var four;
var five;
var six;
var url_scheme;
// cdk列表
var cdk_list = [];
var newData;

window.onload = function () {
  // 页面初始化
  if (user_info.account) {
    layer.close(index);
    obj.init();
    obj.share();
  }
};
(window.onresize = function () {
  obj.resize();
}),
  // 监听页面滚动
  $(document).ready(function () {
    $(window).scroll(function () {});
  });
var obj = {
  initPic() {
    $(".clue-num div").removeClass("ani");

    $(".first-container .first-light").fadeOut();
    $(".first-container .first").fadeIn();

    $(".first-container .second-light").fadeOut();
    $(".first-container .second").fadeIn();

    $(".first-container .third-light").fadeOut();
    $(".first-container .third").fadeIn();

    $(".first-container .four-light").fadeOut();
    $(".first-container .four").fadeIn();

    $(".second-container .five-light").fadeOut();
    $(".second-container .five").fadeIn();

    $(".second-container .six").fadeIn();
    $(".second-container .six-light").fadeOut();

    $(".second-container .seven").fadeIn();
    $(".second-container .seven-light").fadeOut();

    $(".second-container .eight").fadeIn();
    $(".second-container .eight-light").fadeOut();

    $(".third-container .nine").fadeIn();
    $(".third-container .nine-light").fadeOut();

    $(".third-container .ten").fadeIn();
    $(".third-container .ten-light").fadeOut();

    $(".third-container .eleven").fadeIn();
    $(".third-container .eleven-light").fadeOut();

    $(".third-container .twelve").fadeIn();
    $(".third-container .twelve-light").fadeOut();

    $(".four-container .third-ten").fadeIn();
    $(".four-container .third-ten-light").fadeOut();

    $(".four-container .four-ten").fadeIn();
    $(".four-container .four-ten-light").fadeOut();

    $(".four-container .five-ten").fadeIn();
    $(".four-container .five-ten-light").fadeOut();

    $(".four-container .six-ten").fadeIn();
    $(".four-container .six-ten-light").fadeOut();
  },
  // 点亮图标
  lightPic(map_list) {
    if (map_list[0][0] == 1) {
      // $(".first-container .w1").fadeIn();
      $(".first-container .first-light").fadeIn();
      $(".first-container .first").fadeOut();
    }
    // } else if (map_list[0][0] == 1) {
    //   // $(".first-container .w1").fadeOut();
    //   // $(".first-container .first").fadeOut();
    //   // $(".first-container .first-light").fadeIn();
    // }
    else {
      // $(".first-container .w1").fadeOut();
      $(".first-container .first").fadeIn();
      $(".first-container .first-light").fadeOut();
    }
    if (map_list[0][1] == 1) {
      // $(".first-container .w2").fadeIn();
      $(".first-container .second").fadeOut();
      $(".first-container .second-light").fadeIn();
    }
    // } else if (map_list[0][1] == 1) {
    //   $(".first-container .w2").fadeOut();
    //   $(".first-container .second").fadeOut();
    //   $(".first-container .second-light").fadeIn();
    // }
    else {
      // $(".first-container .w2").fadeOut();
      $(".first-container .second").fadeIn();
      $(".first-container .second-light").fadeOut();
    }
    if (map_list[0][2] == 1) {
      // $(".first-container .w3").fadeIn();
      $(".first-container .third").fadeOut();
      $(".first-container .third-light").fadeIn();
    }
    // } else if (map_list[0][2] == 1) {
    //   $(".first-container .w3").fadeOut();
    //   $(".first-container .third").fadeOut();
    //   $(".first-container .third-light").fadeIn();
    // }
    else {
      // $(".first-container .w3").fadeOut();
      $(".first-container .third").fadeIn();
      $(".first-container .third-light").fadeOut();
    }
    if (map_list[0][3] == 1) {
      // $(".first-container .w4").fadeIn();
      $(".first-container .four").fadeOut();
      $(".first-container .four-light").fadeIn();
    }
    // } else if (map_list[0][3] == 1) {
    //   $(".first-container .w4").fadeOut();
    //   $(".first-container .four").fadeOut();
    //   $(".first-container .four-light").fadeIn();
    // }
    else {
      // $(".first-container .w4").fadeOut();
      $(".first-container .four").fadeIn();
      $(".first-container .four-light").fadeOut();
    }

    if (map_list[1][0] == 1) {
      // $(".second-container .w5").fadeIn();
      $(".second-container .five").fadeOut();
      $(".second-container .five-light").fadeIn();
    }
    // } else if (map_list[1][0] == 1) {
    //   $(".second-container .w5").fadeOut();
    //   $(".second-container .five").fadeOut();
    //   $(".second-container .five-light").fadeIn();
    // }
    else {
      // $(".second-container .w5").fadeOut();
      $(".second-container .five").fadeIn();
      $(".second-container .five-light").fadeOut();
    }

    if (map_list[1][1] == 1) {
      $(".second-container .six").fadeOut();
      // $(".second-container .w6").fadeIn();
      $(".second-container .six-light").fadeIn();
    }
    // } else if (map_list[1][1] == 1) {
    //   $(".second-container .six").fadeOut();
    //   $(".second-container .six-light").fadeIn();
    // $(".second-container .w6").fadeOut();
    // }
    else {
      $(".second-container .six").fadeIn();
      $(".second-container .six-light").fadeOut();
      // $(".second-container .w6").fadeOut();
    }
    if (map_list[1][2] == 1) {
      $(".second-container .seven").fadeOut();
      // $(".second-container .w7").fadeIn();
      $(".second-container .seven-light").fadeIn();
    }
    // } else if (map_list[1][2] == 1) {
    //   $(".second-container .seven-light").fadeIn();
    //   $(".second-container .seven").fadeOut();
    //   $(".second-container .w7").fadeOut();
    // }
    else {
      $(".second-container .seven-light").fadeOut();
      $(".second-container .seven").fadeIn();
      // $(".second-container .w7").fadeOut();
    }
    if (map_list[1][3] == 1) {
      $(".second-container .eight").fadeOut();
      // $(".second-container .w8").fadeIn();
      $(".second-container .eight-light").fadeIn();
    }
    // } else if (map_list[1][3] == 1) {
    //   $(".second-container .eight").fadeOut();
    //   $(".second-container .eight-light").fadeIn();
    //   $(".second-container .w8").fadeOut();
    // }
    else {
      $(".second-container .eight").fadeIn();
      $(".second-container .eight-light").fadeOut();
      // $(".second-container .w8").fadeOut();
    }

    if (map_list[2][0] == 1) {
      $(".third-container .nine").fadeOut();
      // $(".third-container .w9").fadeIn();
      $(".third-container .nine-light").fadeIn();
    }
    // } else if (map_list[2][0] == 1) {
    //   $(".third-container .nine").fadeOut();
    //   $(".third-container .nine-light").fadeIn();
    //   $(".third-container .w9").fadeOut();
    // }
    else {
      $(".third-container .nine").fadeIn();
      $(".third-container .nine-light").fadeOut();
      // $(".third-container .w9").fadeOut();
    }
    if (map_list[2][1] == 1) {
      $(".third-container .ten").fadeOut();
      // $(".third-container .w10").fadeIn();
      $(".third-container .ten-light").fadeIn();
    }
    // } else if (map_list[2][1] == 1) {
    //   $(".third-container .ten").fadeOut();
    //   $(".third-container .ten-light").fadeIn();
    //   $(".third-container .w10").fadeOut();
    // }
    else {
      $(".third-container .ten").fadeIn();
      $(".third-container .ten-light").fadeOut();
      // $(".third-container .w10").fadeOut();
    }

    if (map_list[2][2] == 1) {
      $(".third-container .eleven").fadeOut();
      // $(".third-container .w11").fadeIn();
      $(".third-container .eleven-light").fadeIn();
    }
    // } else if (map_list[2][2] == 1) {
    //   $(".third-container .eleven").fadeOut();
    //   $(".third-container .eleven-light").fadeIn();
    //   $(".third-container .w11").fadeOut();
    // }
    else {
      $(".third-container .eleven").fadeIn();
      $(".third-container .eleven-light").fadeOut();
      // $(".third-container .w11").fadeOut();
    }

    if (map_list[2][3] == 1) {
      $(".third-container .twelve-light").fadeIn();
      $(".third-container .twelve").fadeOut();
      // $(".third-container .w12").fadeIn();
    }
    // } else if (map_list[2][3] == 1) {
    //   $(".third-container .twelve").fadeOut();
    //   $(".third-container .twelve-light").fadeIn();
    //   $(".third-container .w12").fadeOut();
    // }
    else {
      $(".third-container .twelve").fadeIn();
      $(".third-container .twelve-light").fadeOut();
      // $(".third-container .w12").fadeOut();
    }
    if (map_list[3][0] == 1) {
      $(".four-container .third-ten-light").fadeIn();
      $(".four-container .third-ten").fadeOut();
      // $(".four-container .w13").fadeIn();
    }
    // } else if (map_list[3][0] == 1) {
    //   $(".four-container .third-ten-light").fadeIn();
    //   $(".four-container .third-ten").fadeOut();
    //   $(".four-container .w13").fadeOut();
    // }
    else {
      $(".four-container .third-ten-light").fadeOut();
      $(".four-container .third-ten").fadeIn();
      // $(".four-container .w13").fadeOut();
    }

    if (map_list[3][1] == 1) {
      $(".four-container .four-ten").fadeOut();
      // $(".four-container .w14").fadeIn();
      $(".four-container .four-ten-light").fadeIn();
    }
    // } else if (map_list[3][1] == 1) {
    //   $(".four-container .four-ten").fadeOut();
    //   $(".four-container .four-ten-light").fadeIn();
    //   $(".four-container .w14").fadeOut();
    // }
    else {
      $(".four-container .four-ten").fadeIn();
      $(".four-container .four-ten-light").fadeOut();
      // $(".four-container .w14").fadeOut();
    }

    if (map_list[3][2] == 1) {
      $(".four-container .five-ten").fadeOut();
      // $(".four-container .w15").fadeIn();
      $(".four-container .five-ten-light").fadeIn();
    }
    // } else if (map_list[3][2] == 1) {
    //   $(".four-container .five-ten").fadeOut();
    //   $(".four-container .five-ten-light").fadeIn();
    //   $(".four-container .w15").fadeOut();
    // }
    else {
      $(".four-container .five-ten").fadeIn();
      $(".four-container .five-ten-light").fadeOut();
      // $(".four-container .w15").fadeOut();
    }

    if (map_list[3][3] == 1) {
      $(".four-container .six-ten-light").fadeIn();
      $(".four-container .six-ten").fadeOut();
    }
    // $(".four-container .w16").fadeIn();
    // } else if (map_list[3][3] == 1) {
    //   $(".four-container .six-ten").fadeOut();
    //   $(".four-container .six-ten-light").fadeIn();
    //   $(".four-container .w16").fadeOut();
    // }
    else {
      $(".four-container .six-ten").fadeIn();
      $(".four-container .six-ten-light").fadeOut();
      // $(".four-container .w16").fadeOut();
    }
  },
  // 领取CKD
  getCDK(cdk_id, type) {
    obj.removeClick();
    $(".prevent-wrap").addClass("prevent-wrap-true");
    var index = layer.load(2, { shade: [0.1, "#fff"] });
    $.ajax({
      url: api + "/ares/reservation/reward",
      type: "POST",
      xhrFields: { withCredentials: true },
      data: {
        cdk_id,
      },
      success: function (json) {
        if (json.code != 200) {
          layer.msg(json.message);
          obj.removeClick();
          obj.activityInit();
          return;
        } else {
          // 弹出领取CDK弹窗
          var cdk = json.data.cdk;
          if (type == 1) {
            $(".five-reward-popup .code-num").html(cdk);
            $(".five-reward-popup").fadeIn();
          }
          if (type == 2) {
            $(".ten-reward-popup .code-num").html(cdk);
            $(".ten-reward-popup").fadeIn();
          }
          if (type == 3) {
            $(".get-reward-popup .code-num").html(cdk);
            $(".get-reward-popup").fadeIn();
          }
          obj.removeClick();
          obj.activityInit();
          layer.msg(json.message);
        }
      },
      complete: function () {
        layer.close(index);
        setTimeout(() => {
          $(".prevent-wrap").removeClass("prevent-wrap-true");
        }, 1000);
      },
    });
  },
  // 点亮图片位置
  clickLightPic(map_id) {
    $(".prevent-wrap").addClass("prevent-wrap-true");
    var index = layer.load(2, { shade: [0.1, "#fff"] });
    $.ajax({
      url: api + "/ares/reservation/make",
      type: "POST",
      xhrFields: { withCredentials: true },
      data: {
        map_id,
      },
      success: function (json) {
        if (json.code != 200) {
          layer.msg(json.message);
          obj.removeClick();
          obj.activityInit();
          return;
        }
        if (json.code == 200) {
          if (map_id == "0_0") {
            $(".first-container .first").addClass("ani");
          }
          if (map_id == "0_1") {
            $(".first-container .second").addClass("ani");
          }
          if (map_id == "0_2") {
            $(".first-container .third").addClass("ani");
          }
          if (map_id == "0_3") {
            $(".first-container .four").addClass("ani");
          }
          if (map_id == "1_0") {
            $(".second-container .five").addClass("ani");
          }
          if (map_id == "1_1") {
            $(".second-container .six").addClass("ani");
          }
          if (map_id == "1_2") {
            $(".second-container .seven").addClass("ani");
          }
          if (map_id == "1_3") {
            $(".second-container .eight").addClass("ani");
          }
          if (map_id == "2_0") {
            $(".third-container .nine").addClass("ani");
          }
          if (map_id == "2_1") {
            $(".third-container  .ten").addClass("ani");
          }
          if (map_id == "2_2") {
            $(".third-container  .eleven").addClass("ani");
          }
          if (map_id == "2_3") {
            $(".third-container  .twelve").addClass("ani");
          }
          if (map_id == "3_0") {
            $(".four-container .third-ten").addClass("ani");
          }
          if (map_id == "3_1") {
            $(".four-container .four-ten").addClass("ani");
          }
          if (map_id == "3_2") {
            $(".four-container .five-ten").addClass("ani");
          }
          if (map_id == "3_3") {
            $(".four-container .six-ten").addClass("ani");
          }

          layer.msg(json.message);
          obj.activityInit();
          obj.removeClick();
        }
      },
      complete: function () {
        setTimeout(() => {
          $(".prevent-wrap").removeClass("prevent-wrap-true");
        }, 1000);
        layer.close(index);
      },
    });
  },
  removeClick() {
    $(".active-item1").off("click");
    $(".active-item2").off("click");
    $(".active-item3").off("click");
    $(".init-new").off("click");
    $(".new-no-get").off("click");
    $(".init-first").off("click");
    $(".first-no-get").off("click");
    $(".init-second").off("click");
    $(".second-no-get").off("click");
    $(".init-five").off("click");
    $(".five-no-get").off("click");
    $(".init-four").off("click");
    $(".four-no-get").off("click");
    $(".init-third").off("click");
    $(".third-no-get").off("click");
  },

  replaceNum() {
    if (completed_num == 0) {
      $(".get-clue span").removeClass("clue-num-15");
      $(".get-clue span").removeClass("clue-num-13");
      $(".get-clue span").removeClass("clue-num-12");
      $(".get-clue span").removeClass("clue-num-11");
      $(".get-clue span").removeClass("clue-num-14");
      $(".get-clue span").removeClass("clue-num-10");
      $(".get-clue span").removeClass("clue-num-9");
      $(".get-clue span").removeClass("clue-num-8");
      $(".get-clue span").removeClass("clue-num-7");
      $(".get-clue span").removeClass("clue-num-6");
      $(".get-clue span").removeClass("clue-num-5");
      $(".get-clue span").removeClass("clue-num-4");
      $(".get-clue span").removeClass("clue-num-3");
      $(".get-clue span").removeClass("clue-num-2");
      $(".get-clue span").removeClass("clue-num-1");
      $(".get-clue span").addClass("clue-num-0");
    }
    if (completed_num == 1) {
      $(".get-clue span").addClass("clue-num-1");
      $(".get-clue span").removeClass("clue-num-0");
    }
    if (completed_num == 2) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-2");
      $(".get-clue span").removeClass("clue-num-1");
    }
    if (completed_num == 3) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-3");
      $(".get-clue span").removeClass("clue-num-2");
    }
    if (completed_num == 4) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-4");
      $(".get-clue span").removeClass("clue-num-3");
    }
    if (completed_num == 5) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-5");
      $(".get-clue span").removeClass("clue-num-4");
    }
    if (completed_num == 6) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-6");
      $(".get-clue span").removeClass("clue-num-5");
    }

    if (completed_num == 7) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-7");
      $(".get-clue span").removeClass("clue-num-6");
    }
    if (completed_num == 8) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-8");
      $(".get-clue span").removeClass("clue-num-7");
    }
    if (completed_num == 9) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-9");
      $(".get-clue span").removeClass("clue-num-8");
    }
    if (completed_num == 10) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-10");
      $(".get-clue span").removeClass("clue-num-9");
    }
    if (completed_num == 11) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-11");
      $(".get-clue span").removeClass("clue-num-10");
    }
    if (completed_num == 12) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-12");
      $(".get-clue span").removeClass("clue-num-11");
    }
    if (completed_num == 13) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-13");
      $(".get-clue span").removeClass("clue-num-12");
    }
    if (completed_num == 14) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-14");
      $(".get-clue span").removeClass("clue-num-13");
    }
    if (completed_num == 15) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-15");
      $(".get-clue span").removeClass("clue-num-14");
    }
    if (completed_num == 16) {
      $(".get-clue span").removeClass("clue-num-0");
      $(".get-clue span").addClass("clue-num-16");
      $(".get-clue span").removeClass("clue-num-15");
    }
  },

  // 邀请好友
  inviteFriend: function () {
    var index = layer.load(2, { shade: [0.1, "#fff"] });
    let windowUrl = window.location.search;
    let Url = new URLSearchParams(windowUrl);
    var code;
    for (const [key, value] of Url) {
      obj[key] = value;
      if (key == "invitation_code") {
        code = value;
      }
    }
    if (code) {
      $.ajax({
        url: api + "/ares/reservation/invite",
        type: "POST",
        xhrFields: { withCredentials: true },
        data: {
          invitation_code: code,
        },
        success: function (json) {
          if (json.code != 200) {
            layer.msg(json.message);
          } else {
            layer.msg(json.message);
          }
        },
        complete: function () {
          layer.close(index);
        },
      });
    }
  },
  // 短信 账号登录
  activityInit: function () {
    var index = layer.load(2, { shade: [0.1, "#fff"] });
    // 领取任务奖励
    $.ajax({
      url: api + "/ares/reservation/init",
      type: "GET",
      xhrFields: { withCredentials: true },
      success: function (json) {
        if (json.code == 200) {
          var jsondata = json.data;
          var _activity = jsondata.activity;
          task_list = [..._activity.task_list];
          map_list = _activity.map_list;
          first = task_list[0];
          second = task_list[1];
          third = task_list[2];
          four = task_list[3];
          five = task_list[4];
          six = task_list[5];
          url_scheme = _activity.url_scheme;
          num_times = _activity.num_times;
          $(".num").html(num_times);
          completed_num = _activity.completed_num;
          invitation_code = _activity.invitation_code;
          cdk_list = _activity.cdk_list;
          // obj.getRewardList();
          for (let i = 0; i < cdk_list.length; i++) {
            if (cdk_list[i].id == 1 && cdk_list[i].cdk) {
              $(".get-item1").fadeIn();
            } else if (cdk_list[i].id == 2 && cdk_list[i].cdk) {
              $(".get-item2").fadeIn();
            } else if (cdk_list[i].id == 3 && cdk_list[i].cdk) {
              $(".get-item3").fadeIn();
            }
          }
          if (window.localStorage.getItem("get-clue")) {
            $(".all-set").fadeOut();
            $(".result-picture").fadeIn();
            $(".clue-container").fadeOut();
          }
          obj.lightPic(map_list);
          obj.replaceNum();
          // 进度条
          completed_num == 1 ? $(".progress-line").width(0.45 + "rem") : "";
          completed_num == 2 ? $(".progress-line").width(0.9 + "rem") : "";
          completed_num == 3 ? $(".progress-line").width(1.35 + "rem") : "";
          completed_num == 4 ? $(".progress-line").width(1.8 + "rem") : "";
          completed_num == 5 ? $(".progress-line").width(2.25 + "rem") : "";

          completed_num == 6 ? $(".progress-line").width(3.8 + "rem") : "";
          completed_num == 7 ? $(".progress-line").width(4.3 + "rem") : "";
          completed_num == 8 ? $(".progress-line").width(4.8 + "rem") : "";
          completed_num == 9 ? $(".progress-line").width(5.3 + "rem") : "";
          completed_num == 10 ? $(".progress-line").width(5.8 + "rem") : "";

          // 6.9 7.5 8.1 8.7 9.3
          completed_num == 11 ? $(".progress-line").width(6.9 + "rem") : "";
          completed_num == 12 ? $(".progress-line").width(7.5 + "rem") : "";
          completed_num == 13 ? $(".progress-line").width(8.1 + "rem") : "";
          completed_num == 14 ? $(".progress-line").width(8.7 + "rem") : "";
          completed_num == 15 ? $(".progress-line").width(9.3 + "rem") : "";
          completed_num == 16 ? $(".progress-line").width(11.32 + "rem") : "";

          if (completed_num >= 5) {
            $(".black-dot-1").fadeOut();
            $(".black-dot-1-red").fadeIn();
            $(".item1").fadeOut();
            $(".active-item1").fadeIn();
            $(".active-item1").click(function () {
              obj.getCDK("1", "1");
            });
          }
          if (completed_num >= 10) {
            $(".black-dot-2").fadeOut();
            $(".black-dot-2-red").fadeIn();
            $(".item2").fadeOut();
            $(".active-item2").fadeIn();

            $(".active-item2").fadeIn();
            $(".active-item2").click(function () {
              obj.getCDK("2", "2");
            });
          }
          if (completed_num == 16) {
            $(".black-dot-3").fadeOut();
            $(".black-dot-3-red").fadeIn();
            $(".item3").fadeOut();
            $(".active-item3").fadeIn();

            $(".active-item3").fadeIn();
            $(".active-item3").click(function () {
              obj.getCDK("3", "3");
            });
            if (window.localStorage.getItem("get-clue")) {
              $(".all-set").fadeOut();
            } else {
              $(".all-set").fadeIn();
            }
          }

          // 邀请好友 也不调完成任务接口
          if (first.status == 0) {
            $(".init-first").click(function () {
              $(".go-friend-popup").fadeIn();
              var shareText = `https://ares2.qingcigame.com/booked/enter${timestamp}?invitation_code=${invitation_code}`;
              $(".py-code").html(shareText);
            });
          }

          if (first.status == 1) {
            $(".bottom-container").children(":eq(0)").removeClass("init-first");
            $(".bottom-container").children(":eq(0)").removeClass("first-get");
            $(".bottom-container").children(":eq(0)").addClass("first-no-get");
            // 官方企业微信奖励
            $(".first-no-get").click(function (event) {
              obj.getReward("1");
            });
          } else if (first.status == 2) {
            $(".bottom-container").children(":eq(0)").removeClass("init-first");
            $(".bottom-container")
              .children(":eq(0)")
              .removeClass("first-no-get");
            $(".bottom-container").children(":eq(0)").addClass("first-get");
            $(".first-get").click(function (event) {
              $(".go-friend-popup").fadeIn();
              var shareText = `https://ares2.qingcigame.com/booked/enter${timestamp}?invitation_code=${invitation_code}`;
              $(".py-code").html(shareText);
            });
          }

          // 第三条企业微信 不调完成任务接口
          if (third.status == 0) {
            $(".init-third").click(function () {
              window.location.href = url_scheme;
            });
          }

          if (third.status == 1) {
            $(".bottom-container").children(":eq(2)").removeClass("init-third");
            $(".bottom-container").children(":eq(2)").removeClass("third-get");
            $(".bottom-container").children(":eq(2)").addClass("third-no-get");
            // 官方企业微信奖励
            $(".third-no-get").click(function (event) {
              obj.getReward("3");
            });
          } else if (third.status == 2) {
            $(".bottom-container").children(":eq(2)").removeClass("init-third");
            $(".bottom-container")
              .children(":eq(2)")
              .removeClass("third-no-get");
            $(".bottom-container").children(":eq(2)").addClass("third-get");
            $(".third-get").click(function (event) {
              window.location.href = url_scheme;
            });
          }

          if (second.status == 1) {
            $(".bottom-container")
              .children(":eq(1)")
              .removeClass("init-second");
            $(".bottom-container").children(":eq(1)").removeClass("second-get");
            $(".bottom-container").children(":eq(1)").addClass("second-no-get");
            // 领取QQ奖励
            $(".second-no-get").click(function (event) {
              obj.getReward("2");
            });
          } else if (second.status == 2) {
            $(".bottom-container")
              .children(":eq(1)")
              .removeClass("init-second");
            $(".bottom-container")
              .children(":eq(1)")
              .removeClass("second-no-get");
            $(".bottom-container").children(":eq(1)").addClass("second-get");
            $(".second-get").click(function (event) {
              var url =
                "https://static2.qcplay.com/qq_group_jump/index.html?game_id=41";
              var ua = navigator.userAgent.toLowerCase();
              if (ua.match(/MicroMessenger/i) == "micromessenger") {
                $(".se-qiye-popup").fadeIn();
              } else {
                window.location.href = url;
              }
            });
          }
          if (second.status == 0) {
            $(".init-second").click(function (event) {
              obj.finishTask("2", 2000);
            });
          }

          // tap-tap
          if (four.status == 1) {
            $(".bottom-container").children(":eq(3)").removeClass("init-four");
            $(".bottom-container").children(":eq(3)").removeClass("four-get");
            $(".bottom-container").children(":eq(3)").addClass("four-no-get");
            // 公众号领取奖励
            $(".four-no-get").click(function (event) {
              obj.getReward("4");
            });
          } else if (four.status == 2) {
            $(".bottom-container").children(":eq(3)").removeClass("init-four");
            $(".bottom-container")
              .children(":eq(3)")
              .removeClass("four-no-get");
            $(".bottom-container").children(":eq(3)").addClass("four-get");
            $(".four-get").click(function (event) {
              window.location.href =
                "https://l.taptap.cn/QU26fE2l?channel=rep-rep_nb4ddwofqt3";
            });
          }
          // taptap立即前往
          if (four.status == 0) {
            $(".init-four").click(function (event) {
              obj.finishTask("4", 2000);
            });
          }

          if (five.status == 1) {
            $(".bottom-container").children(":eq(4)").removeClass("init-five");
            $(".bottom-container").children(":eq(4)").removeClass("five-get");
            $(".bottom-container").children(":eq(4)").addClass("five-no-get");
            // 公众号领取奖励
            $(".five-no-get").click(function (event) {
              obj.getReward("5");
            });
          } else if (five.status == 2) {
            $(".bottom-container").children(":eq(4)").removeClass("init-five");
            $(".bottom-container")
              .children(":eq(4)")
              .removeClass("five-no-get");
            $(".bottom-container").children(":eq(4)").addClass("five-get");
            $(".five-get").click(function (event) {
              $(".gzh-popup").fadeIn();
            });
          }
          // 公众号立即前往
          if (five.status == 0) {
            $(".init-five").click(function (event) {
              $(".gzh-popup").fadeIn();
              obj.finishTask("5");
            });
          }

          if (six.status == 1) {
            $(".bottom-container").children(":eq(5)").removeClass("init-new");
            $(".bottom-container").children(":eq(5)").removeClass("new-get");
            $(".bottom-container").children(":eq(5)").addClass("new-no-get");
            // 公众号领取奖励
            $(".new-no-get").click(function (event) {
              obj.getReward("6");
            });
          } else if (six.status == 2) {
            $(".bottom-container").children(":eq(5)").removeClass("init-new");
              $(".bottom-container")
                .children(":eq(5)")
                .removeClass("new-no-get");
              $(".bottom-container").children(":eq(5)").addClass("new-get");
              $(".new-get").click(function (event) {
                var ua = navigator.userAgent.toLocaleLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                  $(".share-popup").fadeIn();
                } else {
                  $(".go-friend-popup").fadeIn();
                  var shareText = `https://ares2.qingcigame.com/booked/enter${timestamp}?invitation_code=${invitation_code}`;
                  $(".py-code").html(shareText);
                }
              });
          }
          // 公众号立即前往
          if (six.status == 0) {
            $(".init-new").click(function (event) {
              var ua = navigator.userAgent.toLocaleLowerCase();
              if (ua.match(/MicroMessenger/i) == "micromessenger") {
                $(".share-popup").fadeIn();
              } else {
                $(".go-friend-popup").fadeIn();
                var shareText = `https://ares2.qingcigame.com/booked/enter${timestamp}?invitation_code=${invitation_code}`;
                $(".py-code").html(shareText);
              }
              obj.finishTask("6", 2000);
            });
          }
        } else {
          obj.clearAllData();
        }
      },
      complete: function () {
        layer.close(index);
      },
    });
  },
  clearAllData: function () {
    $(".all-set").fadeOut();
    $(".result-picture").fadeOut();

    $(".bottom-container").children(":eq(5)").removeClass("new-get");
    $(".bottom-container").children(":eq(5)").removeClass("new-no-get");
    $(".bottom-container").children(":eq(5)").addClass("init-new");

    $(".bottom-container").children(":eq(0)").removeClass("first-get");
    $(".bottom-container").children(":eq(0)").removeClass("first-no-get");
    $(".bottom-container").children(":eq(0)").addClass("init-first");

    $(".bottom-container").children(":eq(1)").removeClass("second-get");
    $(".bottom-container").children(":eq(1)").removeClass("second-no-get");
    $(".bottom-container").children(":eq(1)").addClass("init-second");

    $(".bottom-container").children(":eq(2)").removeClass("third-get");
    $(".bottom-container").children(":eq(2)").removeClass("third-no-get");
    $(".bottom-container").children(":eq(2)").addClass("init-third");

    $(".bottom-container").children(":eq(3)").removeClass("four-get");
    $(".bottom-container").children(":eq(3)").removeClass("four-no-get");
    $(".bottom-container").children(":eq(3)").addClass("init-four");

    $(".bottom-container").children(":eq(4)").removeClass("five-get");
    $(".bottom-container").children(":eq(4)").removeClass("five-no-get");
    $(".bottom-container").children(":eq(4)").addClass("init-five");

    $(".progress-line").width(0);

    $(".black-dot-1").fadeIn();
    $(".black-dot-2").fadeIn();
    $(".black-dot-3").fadeIn();
    $(".black-dot-1-red").fadeOut();
    $(".black-dot-2-red").fadeOut();
    $(".black-dot-3-red").fadeOut();

    $(".item1").fadeIn();
    $(".item2").fadeIn();
    $(".item3").fadeIn();
    $(".active-item1").fadeOut();
    $(".active-item2").fadeOut();
    $(".active-item3").fadeOut();
    $(".get-item1").fadeOut();
    $(".get-item2").fadeOut();
    $(".get-item3").fadeOut();
    obj.initPic();

    completed_num = 0;
    cdk_list = [];
    obj.replaceNum();
  },
  getReward: function (task_id) {
    // 领取奖励
    $(".prevent-wrap").addClass("prevent-wrap-true");
    var index = layer.load(1);
    $.ajax({
      url: api + "/ares/reservation/dice",
      type: "POST",
      xhrFields: { withCredentials: true },
      data: {
        task_id,
      },
      success: function (json) {
        if (json.code != 200) {
          obj.activityInit();
          obj.removeClick();
          layer.msg(json.message);
          return;
        } else {
          obj.activityInit();
          obj.removeClick();
          layer.msg(json.message);
        }
      },
      complete: function () {
        obj.removeClick();
        setTimeout(() => {
          $(".prevent-wrap").removeClass("prevent-wrap-true");
        }, 1000);
        layer.close(index);
      },
    });
  },
  // 完成任务
  finishTask: function (task_id, time) {
    $(".prevent-wrap").addClass("prevent-wrap-true");
    var index = layer.load(1);
    setTimeout(() => {
      $.ajax({
        url: api + "/ares/reservation/task",
        type: "POST",
        xhrFields: { withCredentials: true },
        data: {
          task_id,
        },
        success: function (json) {
          if (json.code != 200) {
            obj.removeClick();
            layer.msg(json.message);
            return;
          } else {
            // layer.msg(json.message);
            obj.activityInit();
            obj.removeClick();
            if (task_id == 2) {
              var url =
                "https://static2.qcplay.com/qq_group_jump/index.html?game_id=41";
              var ua = navigator.userAgent.toLowerCase();
              if (ua.match(/MicroMessenger/i) == "micromessenger") {
                $(".se-qiye-popup").fadeIn();
              } else {
                window.location.href = url;
              }
            }
            if (task_id == 4) {
              setTimeout(() => {
                window.location.href =
                  "https://l.taptap.cn/QU26fE2l?channel=rep-rep_nb4ddwofqt3";
              }, 1500);
            }
          }
        },
        complete: function () {
          setTimeout(() => {
            $(".prevent-wrap").removeClass("prevent-wrap-true");
          }, 1000);
          layer.close(index);
        },
      });
    }, time);
  },
  //
  login: function () {
    // 短信登录

    $(".sms-login").click(function () {
      var phone = $(".phone-inp");
      var code = $("input[name=sms_code]");
      if (!phone.val()) {
        layer.msg("请输入手机号", { time: 2000 });
        return false;
      }
      if (!code.val()) {
        layer.msg("请输入验证码", { time: 2000 });
        return false;
      }

      var index = layer.load(1);
      $.ajax({
        url: api + "/login/sms",
        type: "POST",
        xhrFields: { withCredentials: true },
        data: {
          account: phone.val(),
          sms_code: code.val(),
        },
        success: function (json) {
          if (json.code != 200) {
            layer.msg(json.message);
            return;
          } else {
            window.localStorage.setItem("access_token", json.data.access_token);
            user_info.phone = json.data.phone; // 手机号
            user_info.access_token = json.data.access_token;
            user_info.account = json.data.account;
            user_info.user_id = json.data.user_id;
            $(".register-popup").fadeOut(); // 预约输入-弹窗关闭
            obj.inviteFriend();
            obj.activityInit(); // 获取用户活动页面初始化
            obj.removeClick();
            // header
            $(".phone-number").html(user_info.account); // header登录账户显示
            if (user_info.account !== null) {
              $(".login-btn").fadeOut();
              $(".logout-btn").fadeIn();
            } else {
              $(".account").html("");
            }
            layer.msg("登录成功");
          }
        },
        complete: function () {
          // $(".account-login").off('click')
          layer.close(index);
        },
      });
    });

    // 账号密码登录
    $(".account-login").click(function () {
      var phone = $(".account");
      var code = $("input[name=password]");
      if (!phone.val()) {
        layer.msg("请输入账号", { time: 2000 });
        return false;
      }
      if (!code.val()) {
        layer.msg("请输入密码", { time: 2000 });
        return false;
      }

      var index = layer.load(1);
      $.ajax({
        url: api + "/login/account",
        type: "POST",
        xhrFields: { withCredentials: true },
        data: {
          account: phone.val(),
          password: code.val(),
        },
        success: function (json) {
          if (json.code != 200) {
            layer.msg(json.message);
            return;
          } else {
            window.localStorage.setItem("access_token", json.data.access_token);
            user_info.phone = json.data.phone; // 手机号
            user_info.access_token = json.data.access_token;
            user_info.account = json.data.account;
            user_info.user_id = json.data.user_id;
            $(".register-popup").fadeOut(); // 预约输入-弹窗关闭
            obj.inviteFriend();
            obj.activityInit(); // 获取用户活动页面初始化
            obj.removeClick();
            // header
            $(".phone-number").html(user_info.account); // header登录账户显示
            if (user_info.account !== null) {
              $(".login-btn").fadeOut();
              $(".logout-btn").fadeIn();
              $(".phone-number").fadeIn();
            } else {
              $(".account").html("");
            }

            layer.msg("登录成功");
          }
        },
        complete: function () {
          layer.close(index);
        },
      });
    });

    $(".get-code").on("click", "a", function (event) {
      var phone = $(".phone-inp");
      if (!phone.val()) {
        layer.msg("请输入手机号", { time: 2000 });
        return false;
      }

      var index = layer.load(1);
      $.ajax({
        url: api + "/login/sms/send",
        type: "POST",
        xhrFields: { withCredentials: true },
        data: {
          mobile: phone.val(),
          channel: "login",
        },
        success: function (json) {
          if (json.code != 200) {
            layer.msg(json.message);
            return;
          } else {
            // 倒计时
            time();
          }
        },
        complete: function () {
          layer.close(index);
        },
      });

      // 60s倒计时
      var wait = 60;
      function time() {
        if (wait == 0) {
          $(".get-code div a").remove();
          $(".get-code div").html("<a>获取验证码</a>");
          wait = 60;
        } else {
          $(".get-code div a").remove();
          $(".get-code div").html("<a>" + wait + "秒</a>");
          wait--;
          setTimeout(function () {
            time();
          }, 1000);
        }
      }
    });
  },
  // 复制SDK
  // 之前的
  init: function () {
    // 领取任务奖励
    function preloading() {
      //图片预加载
      var queue = new createjs.LoadQueue();
      queue.on(
        "progress",
        function (e) {
          //加载中的进度
          if (e.progress * 100 >= 10) {
            $(".loding_time p").html(parseInt(e.progress * 100) + "%");
          }
          var numbers = e.progress * 100;
        },
        this
      );
      queue.on(
        "complete",
        function (e) {
          //加载完成执行操作
          var _this = this;
          $(".loding_time").remove();
          $(".preloading").addClass("preloading-ani").fadeOut(1000);
          $(".index").addClass("index-show");
          setTimeout(function () {
            $(".preloading").remove();
          }, 1000);
        },
        this
      );
      queue.loadManifest([
        //加载图片，不包括后台的
        "/official/images/mobile/one-7cb9049318.png",
        "/official/images/mobile/two-20edc815c9.png",
        "/official/images/mobile/three-590424105f.png",
        "/official/images/mobile/four-01cb0df9bf.png",
        "/official/images/mobile/five-45c24917df.png",
        "/official/images/mobile/wechat-c3f158b305.png",
        "/official/images/mobile/weibo-bb7276c9fe.png",
        "/official/images/mobile/age_tip-183b5bfaf1.png",
        "/official/images/mobile/app_download-176feb732a.png",
        "/official/images/mobile/appoint_btn-615181ba7f.png",
      ]);
    }
    preloading();
    function InitUserInfo() {
      // var index = layer.load(2, { shade: [0.1, "#fff"] });
      $.ajax({
        url: api + "/ares/reservation/init",
        type: "GET",
        xhrFields: { withCredentials: true },
        success: function (json) {
          if (json.code == 200) {
            obj.removeClick();
            var jsondata = json.data;
            var _activity = jsondata.activity;
            user_info.account = jsondata.user_info.account; // 手机号
            // header
            $(".phone-number").html(user_info.account); // header登录账户显示
            if (user_info.account !== null) {
              $(".login-btn").fadeOut();
              $(".logout-btn").fadeIn();
            } else {
              $(".account").html("");
            }

            if (window.localStorage.getItem("get-clue")) {
              $(".all-set").fadeOut();
              $(".result-picture").fadeIn();
              $(".clue-container").fadeOut();
            }

            task_list = [..._activity.task_list];
            map_list = _activity.map_list;
            first = task_list[0];
            second = task_list[1];
            third = task_list[2];
            four = task_list[3];
            five = task_list[4];
            six = task_list[5];
            url_scheme = _activity.url_scheme;
            num_times = _activity.num_times;
            $(".num").html(num_times);
            completed_num = _activity.completed_num;
            invitation_code = _activity.invitation_code;
            cdk_list = _activity.cdk_list;
            // obj.getRewardList();
            for (let i = 0; i < cdk_list.length; i++) {
              if (cdk_list[i].id == 1 && cdk_list[i].cdk) {
                $(".get-item1").fadeIn();
              } else if (cdk_list[i].id == 2 && cdk_list[i].cdk) {
                $(".get-item2").fadeIn();
              } else if (cdk_list[i].id == 3 && cdk_list[i].cdk) {
                $(".get-item3").fadeIn();
              }
            }
            obj.lightPic(map_list);
            obj.replaceNum();
            // 进度条?
            completed_num == 1 ? $(".progress-line").width(0.45 + "rem") : "";
            completed_num == 2 ? $(".progress-line").width(0.9 + "rem") : "";
            completed_num == 3 ? $(".progress-line").width(1.35 + "rem") : "";
            completed_num == 4 ? $(".progress-line").width(1.8 + "rem") : "";
            completed_num == 5 ? $(".progress-line").width(2.25 + "rem") : "";

            completed_num == 6 ? $(".progress-line").width(3.8 + "rem") : "";
            completed_num == 7 ? $(".progress-line").width(4.3 + "rem") : "";
            completed_num == 8 ? $(".progress-line").width(4.8 + "rem") : "";
            completed_num == 9 ? $(".progress-line").width(5.3 + "rem") : "";
            completed_num == 10 ? $(".progress-line").width(5.8 + "rem") : "";

            // 6.9 7.5 8.1 8.7 9.3
            completed_num == 11 ? $(".progress-line").width(6.9 + "rem") : "";
            completed_num == 12 ? $(".progress-line").width(7.5 + "rem") : "";
            completed_num == 13 ? $(".progress-line").width(8.1 + "rem") : "";
            completed_num == 14 ? $(".progress-line").width(8.7 + "rem") : "";
            completed_num == 15 ? $(".progress-line").width(9.3 + "rem") : "";
            completed_num == 16 ? $(".progress-line").width(11.32 + "rem") : "";
            if (completed_num >= 5) {
              $(".black-dot-1").fadeOut();
              $(".black-dot-1-red").fadeIn();
              $(".item1").fadeOut();
              $(".active-item1").fadeIn();
              $(".active-item1").click(function () {
                obj.getCDK("1", "1");
              });
            }
            if (completed_num >= 10) {
              $(".black-dot-2").fadeOut();
              $(".black-dot-2-red").fadeIn();
              $(".item2").fadeOut();
              $(".active-item2").fadeIn();

              $(".active-item2").fadeIn();
              $(".active-item2").click(function () {
                obj.getCDK("2", "2");
              });
            }
            if (completed_num == 16) {
              $(".black-dot-3").fadeOut();
              $(".black-dot-3-red").fadeIn();
              $(".item3").fadeOut();
              $(".active-item3").fadeIn();

              $(".active-item3").fadeIn();
              $(".active-item3").click(function () {
                obj.getCDK("3", "3");
              });
              if (window.localStorage.getItem("get-clue")) {
                $(".all-set").fadeOut();
              } else {
                $(".all-set").fadeIn();
              }
            }

            if (six.status == 1) {
              $(".bottom-container").children(":eq(5)").removeClass("init-new");
              $(".bottom-container").children(":eq(5)").removeClass("new-get");
              $(".bottom-container").children(":eq(5)").addClass("new-no-get");
              $(".new-no-get").click(function (event) {
                obj.getReward("6");
              });
            } else if (six.status == 2) {
              $(".bottom-container").children(":eq(5)").removeClass("init-new");
              $(".bottom-container")
                .children(":eq(5)")
                .removeClass("new-no-get");
              $(".bottom-container").children(":eq(5)").addClass("new-get");
              $(".new-get").click(function (event) {
                var ua = navigator.userAgent.toLocaleLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                  $(".share-popup").fadeIn();
                } else {
                  $(".go-friend-popup").fadeIn();
                  var shareText = `https://ares2.qingcigame.com/booked/enter${timestamp}?invitation_code=${invitation_code}`;
                  $(".py-code").html(shareText);
                }
              });
            }
            if (six.status == 0) {
              $(".init-new").click(function (event) {
                var ua = navigator.userAgent.toLocaleLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                  $(".share-popup").fadeIn();
                } else {
                  $(".go-friend-popup").fadeIn();
                  var shareText = `https://ares2.qingcigame.com/booked/enter${timestamp}?invitation_code=${invitation_code}`;
                  $(".py-code").html(shareText);
                }
                obj.finishTask("6",2000);
              });
            }

            // 邀请好友 也不调完成任务接口
            if (first.status == 0) {
              $(".init-first").click(function () {
                $(".go-friend-popup").fadeIn();
                var shareText = `https://ares2.qingcigame.com/booked/enter${timestamp}?invitation_code=${invitation_code}`;
                $(".py-code").html(shareText);
              });
            }

            if (first.status == 1) {
              $(".bottom-container")
                .children(":eq(0)")
                .removeClass("init-first");
              $(".bottom-container")
                .children(":eq(0)")
                .removeClass("first-get");
              $(".bottom-container")
                .children(":eq(0)")
                .addClass("first-no-get");
              // 官方企业微信奖励
              $(".first-no-get").click(function (event) {
                obj.getReward("1");
              });
            } else if (first.status == 2) {
              $(".bottom-container")
                .children(":eq(0)")
                .removeClass("init-first");
              $(".bottom-container")
                .children(":eq(0)")
                .removeClass("first-no-get");
              $(".bottom-container").children(":eq(0)").addClass("first-get");
              $(".first-get").click(function (event) {
                $(".init-first").click(function () {
                  $(".go-friend-popup").fadeIn();
                  var shareText = `https://ares2.qingcigame.com/booked/enter${timestamp}?invitation_code=${invitation_code}`;
                  $(".py-code").html(shareText);
                });
              });
            }

            // 第三条企业微信 不调完成任务接口
            if (third.status == 0) {
              $(".init-third").click(function () {
                window.location.href = url_scheme;
              });
            }

            if (third.status == 1) {
              $(".bottom-container")
                .children(":eq(2)")
                .removeClass("init-third");
              $(".bottom-container")
                .children(":eq(2)")
                .removeClass("third-get");
              $(".bottom-container")
                .children(":eq(2)")
                .addClass("third-no-get");
              // 官方企业微信奖励
              $(".third-no-get").click(function (event) {
                obj.getReward("3");
              });
            } else if (third.status == 2) {
              $(".bottom-container")
                .children(":eq(2)")
                .removeClass("init-third");
              $(".bottom-container")
                .children(":eq(2)")
                .removeClass("third-no-get");
              $(".bottom-container").children(":eq(2)").addClass("third-get");
              $(".third-get").click(function (event) {
                window.location.href = url_scheme;
              });
            }

            if (second.status == 1) {
              $(".bottom-container")
                .children(":eq(1)")
                .removeClass("init-second");
              $(".bottom-container")
                .children(":eq(1)")
                .removeClass("second-get");
              $(".bottom-container")
                .children(":eq(1)")
                .addClass("second-no-get");
              // 领取QQ奖励
              $(".second-no-get").click(function (event) {
                obj.getReward("2");
              });
            } else if (second.status == 2) {
              $(".bottom-container")
                .children(":eq(1)")
                .removeClass("init-second");
              $(".bottom-container")
                .children(":eq(1)")
                .removeClass("second-no-get");
              $(".bottom-container").children(":eq(1)").addClass("second-get");
              $(".second-get").click(function (event) {
                var url =
                  "https://static2.qcplay.com/qq_group_jump/index.html?game_id=41";
                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                  $(".se-qiye-popup").fadeIn();
                } else {
                  window.location.href = url;
                }
              });
            }
            if (second.status == 0) {
              $(".init-second").click(function (event) {
                obj.finishTask("2", 2000);
              });
            }

            // tap-tap
            if (four.status == 1) {
              $(".bottom-container")
                .children(":eq(3)")
                .removeClass("init-four");
              $(".bottom-container").children(":eq(3)").removeClass("four-get");
              $(".bottom-container").children(":eq(3)").addClass("four-no-get");
              // 公众号领取奖励
              $(".four-no-get").click(function (event) {
                obj.getReward("4");
              });
            } else if (four.status == 2) {
              $(".bottom-container")
                .children(":eq(3)")
                .removeClass("init-four");
              $(".bottom-container")
                .children(":eq(3)")
                .removeClass("four-no-get");
              $(".bottom-container").children(":eq(3)").addClass("four-get");
              $(".four-get").click(function (event) {
                window.location.href =
                  "https://l.taptap.cn/QU26fE2l?channel=rep-rep_nb4ddwofqt3";
              });
            }
            // taptap立即前往
            if (four.status == 0) {
              $(".init-four").click(function (event) {
                obj.finishTask("4", 2000);
              });
            }

            if (five.status == 1) {
              $(".bottom-container")
                .children(":eq(4)")
                .removeClass("init-five");
              $(".bottom-container").children(":eq(4)").removeClass("five-get");
              $(".bottom-container").children(":eq(4)").addClass("five-no-get");
              // 公众号领取奖励
              $(".five-no-get").click(function (event) {
                obj.getReward("5");
              });
            } else if (five.status == 2) {
              $(".bottom-container")
                .children(":eq(4)")
                .removeClass("init-five");
              $(".bottom-container")
                .children(":eq(4)")
                .removeClass("five-no-get");
              $(".bottom-container").children(":eq(4)").addClass("five-get");
              $(".five-get").click(function (event) {
                $(".gzh-popup").fadeIn();
              });
            }
            // 公众号立即前往
            if (five.status == 0) {
              $(".init-five").click(function (event) {
                $(".gzh-popup").fadeIn();
                obj.finishTask("5");
              });
            }
          } else {
            layer.msg(json.message);
            obj.removeClick();
            obj.clearAllData();
          }
        },
        complete: function () {
          $(".init-first").on("click", function () {
            if (!user_info.account) {
              layer.msg("很抱歉,请先登录");
            }
          });
          $(".init-new").on("click", function () {
            if (!user_info.account) {
              layer.msg("很抱歉,请先登录");
            }
          });
          $(".init-second").on("click", function () {
            if (!user_info.account) {
              layer.msg("很抱歉,请先登录");
            }
          });
          $(".init-five").on("click", function () {
            if (!user_info.account) {
              layer.msg("很抱歉,请先登录");
            }
          });
          $(".init-four").on("click", function () {
            if (!user_info.account) {
              layer.msg("很抱歉,请先登录");
            }
          });
          $(".init-third").on("click", function () {
            if (!user_info.account) {
              layer.msg("很抱歉,请先登录");
            }
          });
          // layer.close(index);
        },
      });
    }
    if (window.localStorage.getItem("access_token")) {
      InitUserInfo();
    }
    obj.initPic();
    let windowUrl = window.location.search;
    let Url = new URLSearchParams(windowUrl);
    var code;
    for (const [key, value] of Url) {
      obj[key] = value;
      if (key == "invitation_code") {
        code = value;
      }
    }
    if (code) {
      // var index = layer.load(2, { shade: [0.1, "#fff"] });
      $.ajax({
        url: api + "/ares/reservation/invite",
        type: "POST",
        xhrFields: { withCredentials: true },
        data: {
          invitation_code: code,
        },
        success: function (json) {
          if (json.code != 200) {
            setTimeout(function () {
              if ($(".phone-number").html()) {
                layer.msg(json.message);
              } else {
                layer.msg("点击右上角“登录”登录成功即可助力好友");
              }
            }, 200);
          } else {
            layer.msg(json.message);
          }
        },
        complete: function () {
          // layer.close(index);
        },
      });
    }
    this.share();
    this.countNum();
    this.indexAjax();
    this.bind(); // 所有绑定事件
    this.clipboardInfo();
    this.resize();
    this.isLogin();
    this.login();
    var active = obj.getQueryString().active;
    $(".swiper-num .cur-num").text(cur_num);
    if (active) {
      $(".nav span").removeClass("checked_bg");
      isClaickNav = true;
      if (active == 1) {
        $(".nav2 span").addClass("checked_bg");
        return (
          $("html, body").animate(
            {
              scrollTop: $(".second").offset().top + "px",
            },
            {
              duration: 500,
              easing: "swing",
            }
          ),
          setTimeout(function () {
            isClaickNav = false;
          }, 600)
        );
      } else if (active == 2) {
        $(".nav3 span").addClass("checked_bg");
        return (
          $("html, body").animate(
            {
              scrollTop: $(".third").offset().top + "px",
            },
            {
              duration: 500,
              easing: "swing",
            }
          ),
          setTimeout(function () {
            isClaickNav = false;
          }, 600)
        );
      } else if (active == 3) {
        $(".nav4 span").addClass("checked_bg");
        return (
          $("html, body").animate(
            {
              scrollTop: $(".fourth").offset().top + "px",
            },
            {
              duration: 500,
              easing: "swing",
            }
          ),
          setTimeout(function () {
            isClaickNav = false;
          }, 600)
        );
      } else if (active == 4) {
        $(".nav5 span").addClass("checked_bg");
        return (
          $("html, body").animate(
            {
              scrollTop: $(".fifth").offset().top + "px",
            },
            {
              duration: 500,
              easing: "swing",
            }
          ),
          setTimeout(function () {
            isClaickNav = false;
          }, 600)
        );
      }
    }
  },
  // 防止外部用户知道url进入未公开页面
  isLogin: function () {
    var type = this.getQueryString() && this.getQueryString().type;
    var isPass = window.localStorage.getItem("isPass");
    if (type == "admin" && isPass != "1") {
      person = prompt("パスワードを入力してください:");
      if (!person || person != "123456a") {
        this.isLogin();
      } else {
        $("body").css({
          display: "block",
        });
        window.localStorage.setItem("isPass", 1);
      }
    } else {
      $("body").css({
        display: "block",
      });
    }
  },
  // 屏幕大小变化
  resize: function () {
    // 适配pc和移动端不同的样式
    var type = this.getQueryString() && this.getQueryString().type;
    var isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
    // 在移动端内
    if (isMobile) {
      var isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isIOS) {
        $(".line").css({
          marginTop: "1rem",
        });
      }
      // 移动端资讯列表样式修改
      $(".news_list_page").css({
        height: "12.375rem",
      });
      // 下面是首页样式修改
      // 当type是admin的时候可以看到全部内容，不是admin的时候只能看到最后两部分的内容
      if (
        // (!type || type !== "admin") &&
        document.documentElement.clientWidth < 720
      ) {
        $("header").hide();
        $(".mobile_menu").show();
      }
      // 平板
      if (document.documentElement.clientWidth >= 720) {
        $("header").show();
        $("header .menu").css({
          right: 0,
        });
        $(".mobile_menu").hide();
        $(".index .logo").css({
          left: "-2rem",
        });
        $(".download").css({
          top: "-50px",
        });
        if (
          // type == "admin" &&
          document.documentElement.clientWidth >= 1024
        ) {
          // 横板平板且显示全部内容
          $(".download").css({
            top: "0px",
          });
        }
      } else {
        $("header").hide();
        $(".mobile_menu").show();
      }
    } else {
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      if (!isMac) {
        $(".line").css({
          marginTop: "10px",
        });
      }
      // 在PC端内
      $(".mobile_menu").hide();
      if (document.documentElement.clientWidth <= 656) {
        $("header .menu").css({
          transform: "scale(0.75)",
          right: "-80px",
        });
      } else if (document.documentElement.clientWidth <= 820) {
        $("header .menu").css({
          transform: "scale(0.85)",
          right: "0",
        });
      } else {
        $("header .menu").css({
          transform: "scale(1)",
          right: "60px",
        });
      }
      // }
    }
  },
  share: function () {
    var share_icon =
      "https://download4.qcplay.com/qcgame-api/4PwM3uU6Az1OaXmdoUWdHwHuSS57BU8ofEgJlnK3.png";
    var share_big_title = "《阿瑞斯病毒2》预约活动开启";
    var share_min_title =
      "末日生存手游《阿瑞斯病毒2》8月8日正式上线，速速预约拿限定外观";
    var api = "https://api.qingcigame.com";
    $.ajax({
      url: api + "/wechat/jssdk",
      type: "POST",
      data: {
        uri: window.location.href,
      },
      success: function (json) {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          wx.config(json.data);
          wx.ready(function () {
            wx.updateAppMessageShareData({
              title: share_big_title, // 分享标题
              desc: share_min_title, // 分享描述
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: share_icon, // 分享图标
              success: function () {},
            });

            wx.updateTimelineShareData({
              title: share_big_title, // 分享标题
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: share_icon, // 分享图标
              success: function () {
                // 设置成功
              },
            });
          });
          return;
        } else {
          try {
            setShareInfo({
              title: share_big_title, // 分享标题
              summary: share_min_title, // 分享内容
              pic: share_icon, // 分享图片
              url: window.location.href, // 分享链接
              // 微信权限验证配置信息，若不在微信传播，可忽略
              WXconfig: {
                swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
                appId: json.data.appId, // 公众号的唯一标识
                timestamp: json.data.timestamp, // 生成签名的时间戳
                nonceStr: json.data.nonceStr, // 生成签名的随机串
                signature: json.data.signature, // 签名
              },
            });
          } catch (err) {}
        }
      },
    });
  },
  // 阿里云埋点
  countNum: function (data) {
    setTimeout(() => {
      try {
        __bl.sum(data);
      } catch (e) {}
    }, 500);
  },
  indexAjax: function () {
    const data = [
      {
        index: "1",
        move_url: "/official/images/mobile/one-7cb9049318.png",
      },
      {
        index: "2",
        move_url: "/official/images/mobile/two-20edc815c9.png",
      },
      {
        index: "3",
        move_url: "/official/images/mobile/three-590424105f.png",
      },
      {
        index: "4",
        move_url: "/official/images/mobile/four-01cb0df9bf.png",
      },
      {
        index: "5",
        move_url: "/official/images/mobile/five-45c24917df.png",
      },
    ];
    $.each(data, function (index, values) {
      var slideshow = `<div class="swiper-slide card${index}">
        <img src="${values.move_url}">
        `;
      $(".swiper-container .swiper-wrapper").append(slideshow);
    });
    if (data.length == 1) {
      obj.swiperInit(0, false);
    } else if (data.length > 0) {
      obj.swiperInit(1000, true);
    }
  },
  clipboardInfo: function () {
    var clipboard = new Clipboard(".copy-btn");
    var clipboard1 = new Clipboard(".copy-link");
    var clipboard2 = new Clipboard(".ten-clue");
    var clipboard3 = new Clipboard(".five-clue");
    var clipboard4 = new Clipboard(".all-clue");
    clipboard4.on("success", function (e) {
      layer.msg("复制成功");
      e.clearSelection();
    });
    clipboard3.on("success", function (e) {
      layer.msg("复制成功");
      e.clearSelection();
    });
    clipboard2.on("success", function (e) {
      layer.msg("复制成功");
      e.clearSelection();
    });
    clipboard1.on("success", function (e) {
      layer.msg("复制成功");
      e.clearSelection();
    });
    clipboard.on("success", function (e) {
      layer.msg("复制成功");
      e.clearSelection();
    });
  },
  // 获取奖励列表
  getRewardList: function (data) {
    $.each(data, function (index, values) {
      var reward_item = `<li class="reward_item">
            <div href="javascript:;">
              <p class="item-title">${values.name}</span>
            </div>
            <div id="copy-btn-${index}" class="item-code">
              <p>${values.sdk}</p>
            </div>
            <div data-clipboard-target="#copy-btn-${index}" class="new-copy-btn copy-btn">
        复制
      </div>
        </li>`;
      $(".content ul").append(reward_item);
    });
  },
  // 点击事件绑定
  bind: function () {
    $(".monitor-btn").on("click", function () {
      var mon_btn = $(this).attr("data-event");
      obj.countNum(mon_btn);
    });
    $(".share-btn").click(function () {
      $(".share-img-popup").fadeOut();
      $(".share-people-popup").fadeIn();
    });
    $(".li-link").click(function () {
      var ua = navigator.userAgent.toLocaleLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        $(".share-popup").fadeIn();
      }
    });
    $(document).ready(function () {
      $("#copyButton").click(function () {
        var $tempInput = $("<input>");

        // 将要复制的文字设置为input元素的值
        $tempInput.val(`https://ares2.qingcigame.com/booked/enter${timestamp}`);
        layer.msg("复制链接成功!");
        // 将input元素追加到页面中
        $("body").append($tempInput);

        // 选中input元素中的文字
        $tempInput.select();

        // 复制选中的文字
        document.execCommand("copy");

        // 移除临时input元素
        $tempInput.remove();
      });
    });

    // 下载按钮
    $(".go-download-btn").on("click", function () {
      var game_id = 41;
      var userAgent = navigator.userAgent;
      var isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let windowUrl = window.location.search;
      let Url = new URLSearchParams(windowUrl);
      var kol;
      for (const [key, value] of Url) {
        obj[key] = value;
        if (key == "kol") {
          kol = value;
        }
      }
      $.ajax({
        type: "get",
        url: "https://api.qingcigame.com/get_url?game_id=" + game_id + "",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        success: function (json) {
          // 微信
          var ua = navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == "micromessenger") {
            $(".download_wrap").fadeIn();
            return;
          }
          if (isiOS) {
            // ios
            obj.countNum('mo-ios-download')
            setTimeout(() => {
              location.href = json.data.ios_down_url;
            }, 200)
          } else {
            if (kol) {
              // 安卓
              obj.countNum('mo-and-' + kol + '-download')
              setTimeout(() => {
                location.href = `https://download4.qcplay.com/apk-v2/${kol}.apk`;
              }, 200)
            } else {
              // 安卓
              obj.countNum('mo-and-official-download')
              setTimeout(() => {
                location.href = json.data.android_down_url;
              }, 200)
            }
          }
        },
      });
    });

    $(".reward-btn").on("click", function () {
      $("html, body").animate(
        {
          scrollTop: "670px",
        },
        {
          duration: 1000,
          easing: "swing",
        }
      );
      if (user_info.account) {
      } else {
        $(".register-popup").fadeIn();
      }
    });
    $(".age-tip").on("click", function () {
      $(".age-popup").fadeIn();
    });
    $(".init-first").on("click", function () {
      if (!user_info.account) {
        layer.msg("很抱歉,请先登录");
      }
    });
    $(".init-new").on("click", function () {
      if (!user_info.account) {
        layer.msg("很抱歉,请先登录");
      }
    });
    $(".init-second").on("click", function () {
      if (!user_info.account) {
        layer.msg("很抱歉,请先登录");
      }
    });
    $(".init-five").on("click", function () {
      if (!user_info.account) {
        layer.msg("很抱歉,请先登录");
      }
    });
    $(".init-four").on("click", function () {
      if (!user_info.account) {
        layer.msg("很抱歉,请先登录");
      }
    });
    $(".init-third").on("click", function () {
      if (!user_info.account) {
        layer.msg("很抱歉,请先登录");
      }
    });
    $(".gzh-btn").on("click", function () {
      $(".gzh-popup").fadeIn();
    });
    $(".qw-btn").on("click", function () {
      $(".qiye-popup").fadeIn();
    });
    $(".xhs-btn").on("click", function () {
      var url =
        "https://www.xiaohongshu.com/user/profile/63d874b00000000027036160?xhsshare=CopyLink&appuid=63d874b00000000027036160&apptime=1722245941&share_id=d67474fe37224c84adcd8cad70c61f7f";
      window.open(url, "_blank").focus();
    });
    $(".tap-btn").on("click", function () {
      var url = "https://l.taptap.cn/XcMrColw?channel=rep-rep_jl6nbbx8bwj";
      window.location.href= url
    });
    $(".go-app").on("click", function () {
      var url =
        "https://apps.apple.com/cn/app/%E9%98%BF%E7%91%9E%E6%96%AF%E7%97%85%E6%AF%922/id6503130455";
      // 微信
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        $(".download-popup").fadeIn();
      } else {
        window.location.href = url
      }
    });
    $(".hykb").on("click", function () {
        window.location.href = "https://www.3839.com/a/128665.htm";
    });
    $(".go-group").on("click", function () {
      var url =
        "https://static2.qcplay.com/qq_group_jump/index.html?game_id=41";
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        $(".se-qiye-popup").fadeIn();
      } else {
        window.open(url, "_blank").focus();
      }
    });
    $(".download-popup").on("click", function () {
      $(".download-popup").fadeOut();
    });
    $(".bz-btn").on("click", function () {
      var url = "https://space.bilibili.com/351910798/";
      window.open(url, "_blank").focus();
    });
    $(".dy-btn").on("click", function () {
      var url = "https://v.douyin.com/iMVYKJfR/";
      window.open(url, "_blank").focus();
    });
    $(".ks-btn").on("click", function () {
      var url = "https://v.kuaishou.com/LWJQNy";
      window.open(url, "_blank").focus();
    });
    // 声音开关
    var audio = document.getElementById("myMusic");
    $(".btn-music").on("click", function () {
      if (audio.paused) {
        audio.play();
        // $(this).find("i").addClass("shut");
        $(this).find("i").removeClass("shut");
      } else {
        audio.pause();
        // $(this).find("i").removeClass("shut");
        $(this).find("i").addClass("shut");
      }
    });

    $(".item1").click(function () {
      if (!user_info.account) {
        layer.msg("很抱歉,请先登录");
      }
    });
    $(".item2").click(function () {
      if (!user_info.account) {
        layer.msg("很抱歉,请先登录");
      }
    });
    $(".item3").click(function () {
      if (!user_info.account) {
        layer.msg("很抱歉,请先登录");
      }
    });
    $(".get-all").click(function () {
      $(".share-img-popup").fadeIn();
      $(".all-set").fadeOut();
      $(".result-picture").fadeIn();
      $(".clue-container").fadeOut();
      window.localStorage.setItem("get-clue", true);
    });
    // 点击图层打开亮图
    // 第一张

    $(".clue-num div").click(function (event) {
      if (!user_info.account) return;
      if (!num_times > 0) {
        layer.msg("很抱歉,次数不足");
        return;
      }

      var data = $(this).attr("data");
      obj.clickLightPic(data);
    });

    // 点击注销
    $(".logout-btn").click(function () {
      // 注销
      var index = layer.load(1);
      $.ajax({
        url: api + "/game/my/disable",
        type: "POST",
        xhrFields: { withCredentials: true },
        data: {},
        success: function (json) {
          if (json.code != 200) {
            layer.msg(json.message);
            user_info = {
              account: null,
              user_id: null,
              access_token: null,
              friend_id: null,
              phone: null,
            };
            return;
          } else {
            $(".login-btn").fadeIn();
            $(".logout-btn").fadeOut();
            $(".phone-number").html("");
            obj.activityInit();
            obj.removeClick();
            obj.clearAllData();
            obj.initPic();
            user_info = {
              account: null,
              user_id: null,
              access_token: null,
              friend_id: null,
              phone: null,
            };
            window.localStorage.removeItem("access_token");
            window.localStorage.removeItem("get-clue");
            layer.msg("注销成功");
          }
        },
        complete: function () {
          obj.removeClick();
          obj.clearAllData();
          $(".init-first").on("click", function () {
            if (!user_info.account) {
              layer.msg("很抱歉,请先登录");
            }
          });
          $(".init-new").on("click", function () {
            if (!user_info.account) {
              layer.msg("很抱歉,请先登录");
            }
          });
          $(".init-second").on("click", function () {
            if (!user_info.account) {
              layer.msg("很抱歉,请先登录");
            }
          });
          $(".init-five").on("click", function () {
            if (!user_info.account) {
              layer.msg("很抱歉,请先登录");
            }
          });
          $(".init-four").on("click", function () {
            if (!user_info.account) {
              layer.msg("很抱歉,请先登录");
            }
          });
          $(".init-third").on("click", function () {
            if (!user_info.account) {
              layer.msg("很抱歉,请先登录");
            }
          });
          $(".click-num .num").html(0);
          $(".clue-container").fadeIn();
          user_info = {
            account: null,
            user_id: null,
            access_token: null,
            friend_id: null,
            phone: null,
          };
          layer.close(index);
        },
      });
    });
    // 点击立即预约-弹窗
    $(".login-btn").click(function (event) {
      $("input").val("");

      $(".register-popup").fadeIn();
    });

    $(".new-copy-btn").click(function (event) {
      var index = $(this).attr("data-index");
    });

    $(".close-bg").click(function (event) {
      $(".se-qiye-popup").fadeOut();
      $(".share-people-popup").fadeOut();
      $(".share-img-popup").fadeOut();
      $(".register-popup").fadeOut();
      $(".rule-popup").fadeOut();
      $(".get-reward-popup").fadeOut();
      $(".five-reward-popup").fadeOut();
      $(".ten-reward-popup").fadeOut();
      $(".reward-list-popup").fadeOut();
      $(".qq-popup").fadeOut();
      $(".gzh-popup").fadeOut();
      $(".go-friend-popup").fadeOut();
      $(".age-popup").fadeOut();
      $(".qiye-popup").fadeOut();
      $(".reward-list-popup .content ul li").remove();
    });

    $(".reward-detail").click(function () {
      obj.activityInit();
      var data = [];
      $(".reward-list-popup").fadeIn();
      for (let i = 0; i < cdk_list.length; i++) {
        if (cdk_list[i].id == 1 && cdk_list[i].cdk) {
          data.push({
            name: "玉米*4",
            sdk: cdk_list[i].cdk,
          });
        } else if (cdk_list[i].id == 2 && cdk_list[i].cdk) {
          data.push({
            name: "旧手机*1、罐头*5",
            sdk: cdk_list[i].cdk,
          });
        } else if (cdk_list[i].id == 3 && cdk_list[i].cdk) {
          data.push({
            name: "“真·限定”上衣*1",
            sdk: cdk_list[i].cdk,
          });
        }
      }
      var newData =
        data.length > 0
          ? data
          : $(".reward-list-popup .content ul li").remove();
      obj.getRewardList(newData);
    });

    $(".share-popup").click(function () {
      $(".share-popup").fadeOut();
    });

    $(".download_wrap").click(function () {
      $(".download_wrap").fadeOut();
    });

    $(".li-wb").click(function () {
      window.location.href = "https://weibo.com/u/6585924742";
    });

    $(".li-wechat").click(function () {
      window.location.href = "weixin://dl/business/?t=OGxk63TAY2p";
    });

    $(".rule-icon").click(function (event) {
      $(".rule-popup").fadeIn();
    });

    $(".li-qq").click(function (event) {
      window.open(
        "https://static2.qcplay.com/qq_group_jump/index.html?game_id=41"
      );
    });

    $(".type-box").on("click", "a", function (event) {
      $(this).addClass("on").siblings().removeClass("on");
      is_type = $(this).attr("data");
      if (is_type == "account") {
        $(".register-popup .register-tab-main-1").fadeOut();
        $(".register-popup .register-tab-main-2").fadeIn();
      } else {
        $(".register-popup .register-tab-main-1").fadeIn();
        $(".register-popup .register-tab-main-2").fadeOut();
      }
    });
  },
  // swiper初始化
  swiperInit: function (autoplay, loop) {
    var swiper = new Swiper(".swiper-container", {
      direction: "horizontal",
      autoplay: autoplay, //可选选项，自动滑动
      loop: true,
      pagination: ".swiper-pagination",
      prevButton: ".swiper-button-prev",
      nextButton: ".swiper-button-next",
      paginationClickable: true,
      centeredSlides: true,
      slideToClickedSlide: true,
      slidesPerView: "auto",
      spaceBetween: 6,

      onSlideChangeStart: function (swiper) {
        var index = $(".swiper-slide-active").attr("data-swiper-slide-index");
        if (index == 0) {
          $(".swiper-num .cur-num").text("01");
        }
        if (index == 1) {
          $(".swiper-num .cur-num").text("02");
        }
        if (index == 2) {
          $(".swiper-num .cur-num").text("03");
        }
        if (index == 3) {
          $(".swiper-num .cur-num").text("04");
        }
        if (index == 4) {
          $(".swiper-num .cur-num").text("05");
        }
      },
    });
  },
  // 获取查询字符串
  getQueryString: function () {
    var queryObj = {};
    var qString = window.location.href.split("?")[1];
    //undefined
    if (!qString) {
      return queryObj;
    }
    qString = qString.indexOf("#") == -1 ? qString : qString.split("#")[0];
    if (!qString) {
      return queryObj;
    }
    var qStringArr = qString.split("&");
    for (var i = 0; i < qStringArr.length; i++) {
      var key = qStringArr[i].split("=")[0];
      var value = qStringArr[i].split("=")[1];
      queryObj[key] = value;
    }
    return queryObj;
  },
};
